import { useTranslation } from "next-i18next"
import { FC } from "react"
import ReactLoading from "react-loading"

interface LoadingProps {
  isLoading?: boolean
  isEmpty?: boolean
}

export const Loading: FC<LoadingProps> = ({ isLoading, isEmpty }) => {
  const { t } = useTranslation("common")

  if (!isLoading && !isEmpty) return null

  if (!isLoading && !!isEmpty) {
    return (
      <div
        style={{ width: "100%", minHeight: "200px", display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        {t("No results found", "No results found")}.
      </div>
    )
  }

  return (
    <div style={{ width: "100%", minHeight: "200px", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <ReactLoading type="spin" color="#37b24d" width="40px" height="40px" />
    </div>
  )
}
